module.exports = __webpack_public_path__ + "assets/img/book-open@1,5x.02f90c6a.svg";